var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { CONSOLIDAR_PANTALLA, ADD_PANTALLA } from '../actions'; // import { PANTALLA_LIBRO_ID, PANTALLA_PORTADA_ID } from '../constantes'
// import PantallaLibroContainer from './../pantalla-libro'
// export function historial(state = [], action) {
//     switch(action.type){
//         case PANTALLA:
//             if (state.length === 1) {
//                 return [action]
//             }
//             const ultimaPantalla = state[state.length - 1]
//             if (action.pantallaId !== ultimaPantalla.pantallaId) {
//                 return [
//                     ...state,
//                     action
//                 ]
//             }
//             return state
//         case PANTALLA_ANTERIOR:
//             if (state.length > 0) {
//                 return state.slice(0, state.length -2)
//             }
//             return state
//         default:
//             return state
//     }
// }

export function pantalla() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case CONSOLIDAR_PANTALLA:
      return action.pantallaId;

    default:
      return state;
  }
}
export function pantallaProps() {
  var _extends2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  if (!action.props) {
    return state;
  }

  switch (action.type) {
    case CONSOLIDAR_PANTALLA:
      // const newState = {...state}    
      // //newState[action.pantallaId] = {...state[action.pantallaId], ...action.props}
      // newState[action.pantallaId] = action.props
      // return newState
      return _extends({}, state, (_extends2 = {}, _extends2[action.pantallaId] = action.props, _extends2));

    default:
      return state;
  }
}
var PANTALLAS_POR_DEFECTO = {}; // PANTALLAS_POR_DEFECTO[PANTALLA_LIBRO_ID] = LibroContainer

export function pantallas() {
  var _extends3;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PANTALLAS_POR_DEFECTO;
  var action = arguments[1];

  switch (action.type) {
    case ADD_PANTALLA:
      // const pantallas = {...state}
      // pantallas[action.pantallaId] = action.pantallaComponent
      // return pantallas
      return _extends({}, state, (_extends3 = {}, _extends3[action.pantallaId] = action.pantallaComponent, _extends3));

    default:
      return state;
  }
}